 
import { IServerSideGetRowsParams } from 'ag-grid-community'
import { ObGrid } from '@outbound-ai/ursa'
import {
  CLAIMS_FILE_COLUMN,
  ROW_MODEL_TYPE,
} from 'features/claims/components/ClaimsTable/Internal/ClaimsTableConstants'
import styled, { css } from 'styled-components'
import { BatchTabType } from '../types'
import { NoContent } from '../utils'
import { createBatchServerSideDataSource } from '../utils/grid'
import { BatchAwaitingEOBConfig } from './AutoCheckGrid/gridConfig'
import { useAppDispatch, useAppSelector } from 'appState/store'
import { useEffect, useState } from 'react'
import { updateCurrentBatch } from '../autoCheckSlice'

export const AwaitingEOB = () => {
  const dispatch = useAppDispatch()
  const { root, refresh } = useAppSelector((state) => state.batch)
  const [gridApi, setGridApi] = useState<any>(null)

  const onGridReady = async (params: IServerSideGetRowsParams) => {
    setGridApi(params)
    if (window.innerWidth > 1600) {
      params.api.sizeColumnsToFit()
    }
    dispatch(updateCurrentBatch({ root: BatchTabType.EOB }))
    const dataSource = createBatchServerSideDataSource(BatchTabType.EOB)
    params.api.setGridOption('serverSideDatasource', dataSource)
  }

  const onFirstDataRendered = (params: any) => {
    params.api.sizeColumnsToFit()
    window.setTimeout(() => {
      const colIds = params.api.getColumns().map((col: any) => col.getColId())
      params.api.autoSizeColumns(colIds)
    })
  }

  useEffect(() => {
    if (refresh && gridApi) {
      if (window.innerWidth > 1600) {
        gridApi.api.sizeColumnsToFit()
      }
      const dataSource = createBatchServerSideDataSource(root)
      gridApi.api.setGridOption('serverSideDatasource', dataSource)
      dispatch(updateCurrentBatch({ root: BatchTabType.EOB, refresh: false }))
    }
  }, [refresh, root])

  return (
    <Div>
      <div className="grid">
        <ObGrid
          reactiveCustomComponents={true}
          columnDefs={BatchAwaitingEOBConfig as any}
          rowModelType={ROW_MODEL_TYPE}
          onGridReady={onGridReady as any}
          defaultColDef={CLAIMS_FILE_COLUMN as any}
          rowHeight={50}
          paginationPageSize={20}
          cacheBlockSize={20}
          noRowsOverlayComponent={NoContent}
          onFirstDataRendered={onFirstDataRendered}
        ></ObGrid>
      </div>
    </Div>
  )
}

const Div = styled.div`
  .grid {
    ${({ theme }) => css`
      height: calc(
        100vh - ${theme.constants.navbarHeight} - ${theme.constants.pageTitleHeight} -
          ${theme.constants.tableHeadHeight} - 90px
      );
    `}
  }
  padding: 1.5rem 1rem 0rem 0rem;
  overflow: hidden;
  position: relative;
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    ${({ theme }) => theme.typography.h5.bold};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
`
